import { ReactNode } from "react";

export default function Tag({ children, color = '#ccc' }: { children: ReactNode; color?: string }) {
  return <span style={{ borderRadius: 4, border: `1px solid ${color}`, color, padding: '5px 10px' }}>{children}</span>
}